// 데미지 숫자 표시 UI 컴포넌트
class DamageNumber {
  constructor(scene, position, damage, color = 0xff0000) {
    this.scene = scene;
    this.position = position.clone();
    this.damage = damage;
    this.color = color;
    this.duration = 1.0; // 1초간 표시
    this.elapsedTime = 0;
    this.isActive = true;

    // 3D 텍스트 생성
    this.createText();

    // 씬에 추가
    this.scene.add(this.textMesh);
  }

  // 3D 텍스트 메쉬 생성
  createText() {
    // 텍스트 지오메트리 생성
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // 캔버스 크기 설정 (더 큰 캔버스로 선명도 향상)
    canvas.width = 256;
    canvas.height = 128;

    // 텍스트 스타일 설정 (게임다운 폰트)
    context.font = "bold 48px Arial, sans-serif";
    context.textAlign = "center";
    context.textBaseline = "middle";

    // 그림자 효과 추가
    context.shadowColor = "rgba(0, 0, 0, 0.8)";
    context.shadowBlur = 4;
    context.shadowOffsetX = 2;
    context.shadowOffsetY = 2;

    // 메인 텍스트 색상
    const colorHex = this.color.toString(16).padStart(6, "0");
    context.fillStyle = `#${colorHex}`;

    // 데미지 텍스트 포맷팅 (정수면 소수점 제거, 아니면 한자리까지)
    const damageText = Number.isInteger(this.damage)
      ? this.damage.toString()
      : this.damage.toFixed(1);

    // 텍스트 그리기 (소숫점 이하 한자리까지 표시)
    context.fillText(damageText, canvas.width / 2, canvas.height / 2);

    // 그림자 효과 초기화
    context.shadowColor = "transparent";
    context.shadowBlur = 0;
    context.shadowOffsetX = 0;
    context.shadowOffsetY = 0;

    // 테두리 효과 추가 (선택적)
    context.strokeStyle = "rgba(255, 255, 255, 0.3)";
    context.lineWidth = 2;
    context.strokeText(damageText, canvas.width / 2, canvas.height / 2);

    // 텍스처 생성
    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;

    // 스프라이트 재질 생성 (항상 카메라를 향함)
    const material = new THREE.SpriteMaterial({
      map: texture,
      transparent: true,
      alphaTest: 0.1,
    });

    // 스프라이트 생성
    this.textMesh = new THREE.Sprite(material);

    // 크기 설정 (적당한 크기로 조정)
    this.textMesh.scale.set(2, 1, 1);

    // 위치 설정 (해골 머리 위쪽)
    this.textMesh.position.copy(this.position);
    this.textMesh.position.y += 2.5; // 해골 머리 위로 올림
  }

  // 업데이트 (매 프레임 호출)
  update(delta) {
    if (!this.isActive) return;

    this.elapsedTime += delta;

    // 시간이 지나면서 위로 올라가고 투명해짐
    const progress = this.elapsedTime / this.duration;

    // 위로 이동 (부드러운 곡선 - 처음엔 빠르게, 나중엔 느리게)
    const moveDistance = progress * progress * 3; // 이차함수로 자연스러운 감속
    this.textMesh.position.y = this.position.y + 2.5 + moveDistance;

    // 좌우로 살짝 흔들리는 효과 (랜덤한 방향으로)
    const shakeAmount = Math.sin(progress * Math.PI * 4) * 0.1 * (1 - progress);
    this.textMesh.position.x = this.position.x + shakeAmount;

    // 크기 변화 (처음엔 작다가 커졌다가 다시 작아짐)
    const scaleProgress = Math.sin(progress * Math.PI);
    const scale = 1.5 + scaleProgress * 0.5;
    this.textMesh.scale.set(scale * 2, scale, 1);

    // 투명도 감소 (나중에 더 빠르게 사라짐)
    const alpha = Math.max(0, Math.pow(1 - progress, 2));
    this.textMesh.material.opacity = alpha;

    // 시간이 끝나면 제거
    if (this.elapsedTime >= this.duration) {
      this.destroy();
    }
  }

  // 카메라 방향으로 회전 (항상 플레이어를 향함)
  lookAtCamera(camera) {
    if (this.textMesh && this.isActive) {
      this.textMesh.lookAt(camera.position);
    }
  }

  // 제거
  destroy() {
    if (this.textMesh) {
      this.scene.remove(this.textMesh);
      this.textMesh.material.dispose();
      this.textMesh = null;
    }
    this.isActive = false;
  }

  // 활성 상태 확인
  isDestroyed() {
    return !this.isActive;
  }
}

// 전역으로 내보내기
if (typeof module !== "undefined" && module.exports) {
  module.exports = DamageNumber;
} else {
  window.DamageNumber = DamageNumber;
}

// webpack 빌드를 위해 default export 추가
export default DamageNumber;
